import React from "react";
import "./bigtitle.css";

const BigTitle = (props) => {
  return (
    <div id={props.id}>
      <p className={"bigTitle " + props.modifier}>
        {props.title.map((line, id) => {
          return <span key={id}>{line}</span>;
        })}
      </p>
    </div>
  );
};

export default BigTitle;
